'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadCardData = exports.LOAD_CARD_DATA = exports.PRODUCT_GROUP_DISCLAIMER_TYPES = exports.PRODUCT_TYPES = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.doLoadPromotion = doLoadPromotion;
exports.doLoadCardData = doLoadCardData;
exports.doLoadLocationData = doLoadLocationData;
exports.loadSaga = loadSaga;
exports.watchSaga = watchSaga;

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _locale = require('redux/modules/locale');

var _bound = require('redux/saga/entities/bound');

var _promotions = require('constants/promotions');

var _verify = require('helpers/verify');

var _planSelection = require('components/CmsPage/modules/PlanSelection/plan-selection.saga');

var _location = require('containers/LocationModal/location.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doLoadPromotion),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(doLoadCardData),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(doLoadLocationData),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(loadSaga),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(watchSaga);

var PRODUCT_TYPES = exports.PRODUCT_TYPES = {
  custom: 'custom',
  promotion: 'promotion'
};

var PRODUCT_GROUP_DISCLAIMER_TYPES = exports.PRODUCT_GROUP_DISCLAIMER_TYPES = {
  none: 'none',
  autoRenewal: 'auto-renewal'
};

var LOAD_CARD_DATA = exports.LOAD_CARD_DATA = 'ProductGroup/LOAD_CARD_DATA';

var loadCardData = exports.loadCardData = function loadCardData() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      productType = _ref.productType,
      productCode = _ref.productCode;

  return {
    type: LOAD_CARD_DATA,
    productType: productType,
    productCode: productCode
  };
};

function doLoadPromotion(client, _ref2) {
  var productCode = _ref2.productCode;
  var promoAlias, msa;
  return _regenerator2.default.wrap(function doLoadPromotion$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          promoAlias = productCode || _promotions.GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS;
          _context.next = 3;
          return (0, _effects.call)(_location.getMsa, client, {}, { redirectBackOnMissing: false });

        case 3:
          msa = _context.sent;

          if ((0, _verify.isEmpty)(msa)) {
            _context.next = 7;
            break;
          }

          _context.next = 7;
          return (0, _effects.call)(_planSelection.doLoadPromotionData, client, msa, promoAlias);

        case 7:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function doLoadCardData(client, _ref3) {
  var productType = _ref3.productType,
      productCode = _ref3.productCode;
  return _regenerator2.default.wrap(function doLoadCardData$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.t0 = productType;
          _context2.next = _context2.t0 === PRODUCT_TYPES.promotion ? 3 : _context2.t0 === PRODUCT_TYPES.custom ? 6 : 6;
          break;

        case 3:
          _context2.next = 5;
          return (0, _effects.call)(doLoadPromotion, client, { productCode: productCode });

        case 5:
          return _context2.abrupt('break', 7);

        case 6:
          return _context2.abrupt('break', 7);

        case 7:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function doLoadLocationData(client) {
  var locations;
  return _regenerator2.default.wrap(function doLoadLocationData$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.all)([(0, _effects.select)(_locale.selectUserDetectedLocation), (0, _effects.select)(_locale.selectUserSelectedLocation)]);

        case 2:
          locations = _context3.sent;
          _context3.next = 5;
          return (0, _effects.all)(locations.filter(Boolean).map(function (_ref4) {
            var lat = _ref4.lat,
                lon = _ref4.lon;
            return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.glsLocation, [client, lat, lon]);
          }));

        case 5:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function loadSaga(client, props) {
  var productType, productCode;
  return _regenerator2.default.wrap(function loadSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          productType = props.productType, productCode = props.productCode;
          _context4.next = 3;
          return (0, _effects.call)(doLoadLocationData, client);

        case 3:
          _context4.next = 5;
          return (0, _effects.call)(doLoadCardData, client, { productType: productType, productCode: productCode });

        case 5:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function watchSaga(client) {
  return _regenerator2.default.wrap(function watchSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, loadCardData().type, loadSaga, client);

        case 2:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}